<div class="design-screen" *ngIf="isReady">
  <app-report-preview class="column report-preview" (closeSnackBar)="closeSnackBar($event)"></app-report-preview>
  <!--<app-property-preview #property class="column property-preview" (closeSnackBar)="closeSnackBar($event)"></app-property-preview>-->
</div>
